import template from './photoList.html';
import controller from './photoList.controller';
import './photoList.scss';

export default {
  restrict: 'E',
  bindings: {
    subRegion: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};



/** WEBPACK FOOTER **
 ** ./client/app/components/common/photoList/photoList.component.js
 **/